/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Adjust_Duration_Reading_SpeedInputs */



/**
* | output |
* | --- |
* | "Adjust Duration to Reading Speed" |
*
* @param {Shortcut_Keys_Name_Adjust_Duration_Reading_SpeedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_adjust_duration_reading_speed = /** @type {((inputs?: Shortcut_Keys_Name_Adjust_Duration_Reading_SpeedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Adjust_Duration_Reading_SpeedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajuster la duree a la vitesse de lecture")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dauer an Lesegeschwindigkeit anpassen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Adatta la durata alla velocità di lettura")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройте продолжительность чтения в соответствии со скоростью чтения.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustar la duración a la velocidad de lectura")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("根据阅读速度调整阅读时长")
	if (locale === "ja") return /** @type {LocalizedString} */ ("読む速度に合わせて期間を調整する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पढ़ने की गति के अनुसार अवधि समायोजित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ajuste a duração à velocidade de leitura.")
	return /** @type {LocalizedString} */ ("Adjust Duration to Reading Speed")
});